<div class="products-view" [formGroup]="listOptionsForm">
    <div class="products-view__loader"></div>

    <div *ngIf="datanew.products?.length" class="products-view__content">
        <div class="products-view__options">
            <div class="view-options view-options--offcanvas--mobile">
                <div class="view-options__filters-button">
                    <button type="button" class="filters-button" (click)="sidebar.open()">
                        <app-icon class="filters-button__icon" name="filters-16" size="16"></app-icon>
                        <span class="filters-button__title">Filters</span>
                        <span class="filters-button__counter" *ngIf="filtersCount > 0">{{ filtersCount }}</span>
                    </button>
                </div>
                <div class="view-options__layout">
                    <div class="layout-switcher">
                        <div class="layout-switcher__list">
                            <button title="Grid" type="button" class="layout-switcher__button"
                                    [ngClass]="{'layout-switcher__button--active': layout === 'grid'}" (click)="setLayout('grid')">

                                <app-icon name="layout-grid-16x16" size="16"></app-icon>
                            </button>
                            <button title="List" type="button" class="layout-switcher__button"
                                    [ngClass]="{'layout-switcher__button--active': layout === 'list'}" (click)="setLayout('list')">

                                <app-icon name="layout-list-16x16" size="16"></app-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="view-options__legend"  *ngIf="showpagination">
                    Showing {{ datanew.pagination.from }}–{{ datanew.pagination.to }}
                    of {{ datanew.pagination.total }}
                </div>
                <div class="view-options__legend"  *ngIf="!showpagination">
                    {{ datanew.products.length }} Products found
                </div>
                <div class="view-options__divider"></div>
                <div class="view-options__control" *ngIf="showpagination">
                    <label for="view-options-sort">Sort By</label>
                    <div>
                        <select class="form-control form-control-sm" id="view-options-sort" formControlName="sort">
                            <option value="default">Default</option>
                            <option value="name_asc">Price (Low To High)</option>
                            <option value="name_desc">Price (High To Low)</option>
                        </select>
                    </div>
                </div>
                <div class="view-options__control" *ngIf="showpagination">
                    <label for="view-options-limit">Show</label>
                    <div>
                        <select class="form-control form-control-sm" id="view-options-limit" formControlName="limit">
                            <option value="15">15</option>
                            <option value="30">30</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="products-view__list products-list" [attr.data-layout]="layout != 'list' ? grid : layout" [attr.data-with-features]="layout == 'grid-with-features' ? 'true' : 'false'">
            <div class="products-list__body">
                <div *ngFor="let product of datanew.products" class="products-list__item ">
                    <app-product-card [product]="product"></app-product-card>
                </div>
            </div>
        </div>

        <div class="products-view__pagination" *ngIf="showpagination">
            <app-pagination formControlName="page" [current]="datanew.pagination.page" [siblings]="2" [total]="datanew.pagination.pages"></app-pagination>
        </div>
    </div>

    <div *ngIf="!datanew.products?.length" class="products-view__empty">
        <div class="products-view__empty-title">No matching items</div>
        <div class="products-view__empty-subtitle">Try resetting the filters</div>
    </div>
</div>
